import { type FC, type PropsWithChildren, type ReactNode } from 'react'

export interface SeatInfoBoxProps extends PropsWithChildren {
  title?: ReactNode
}

export const SeatInfoBox: FC<SeatInfoBoxProps> = ({ title, children }) => (
  <div className='d-flex gap-2 align-items-start rounded-2 zocks-bg-color-gray-100 border zocks-border-color-gray-300 px-3 py-4 mt-2'>
    <i className='bi bi-info-circle zocks-text-gray-600 flex-shrink-0' />
    <div className='d-flex flex-column gap-2'>
      {title ? <span className='paragraph-small bold zocks-text-gray-600'>{title}</span> : null}
      <span className='paragraph-small zocks-text-gray-600'>{children}</span>
    </div>
  </div>
)
